import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwMessage, DwMessageSeverity, DwModalConfig, DwModalHandler, DwModalResult, DwSecurityUserService, 
         isEmptyObject, DwMetaDataService, DwMetaDataServiceToken, DwDateTimeInputOptions, DwMetaDataFormStateService, DwGridEventType } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { EmployeeReviewKickoffModalArgs } from '../../models/emplyoee-review-kickoff-modal-args.model';
import { EmployeeReviewKickoffModalResult } from '../../models/employee-review-kickoff-modal-result.model';


import * as moment_ from 'moment';
import { map, mergeMap } from 'rxjs/operators';
import { EmployeeReviewSummaryEntity, EmployeeReviewEntity, PerformanceManagementMetaDataItemNames, PerformanceManagementMetaDataLookups, 
         EmployeeReviewSummaryTypeEntity } from '../../meta-data/performancemanagement-meta-data.service';
import { PerformanceManagementRepositoryService } from '../../services/performance-management-repository.service';
import { EmployeeReviewSummaryStatus } from '../../meta-data/constants/employee-review-summary-status.enum';
import { EmployeeReviewStatus } from '../../meta-data/constants/employee-review-status.enum';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
const moment = moment_;

@Component({
  selector: 'app-employee-review-kickoff-modal',
  templateUrl: './employee-review-kickoff-modal.component.html',
  styleUrls: ['./employee-review-kickoff-modal.component.scss']
})
export class EmployeeReviewKickoffModalComponent implements OnInit, DwModalHandler {
  reviewYear: number;

  constructor(private pmRepositoryService: PerformanceManagementRepositoryService,
    private dwSecurityUserService: DwSecurityUserService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService) { }

  modalConfig: DwModalConfig<any>;
  evalDueDate: any;
  reviewDueDate: any;
  message: DwMessage;

  employeeLookupId = PerformanceManagementMetaDataLookups.EthosUserBySupervisorPlusIndirect;
  allowAddEmployees: boolean = false;
  hideAddEmployees: boolean = false;
  employeeIdToAdd?: number;
  params: any[] = [];

  dateOptions: DwDateTimeInputOptions = {
    minDate: {
      isToday: true,
    }
  }

  closeModal: EventEmitter<DwModalResult<any>>;
  kickoffArgs: EmployeeReviewKickoffModalArgs;

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    let modalResult: DwModalResult<EmployeeReviewKickoffModalResult> = {
      cancelled: false,
      buttonCommand: buttonConfig.command,
      closeModal: true,
    };

    this.message = null;

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:
        return this.startReviewSummarySave();

      case DwButtonCommand.cancel:
        modalResult.cancelled = true;
        break;
    }

    return of(modalResult);
  }

  ngOnInit(): void {
    
    this.hideAddEmployees = this.modalConfig.data.eventType == DwGridEventType.rowActionButton;

    // Set the arguments
    this.kickoffArgs = this.modalConfig.data;

    this.evalDueDate = moment().add(14, 'days').format("MM/DD/YYYY");
    this.reviewDueDate = moment().add(28, 'days').format("MM/DD/YYYY");

    this.reviewYear = moment().year();

    // Set parameters for the subordinate employee drop-down
    const wachterUser = new WachterUserExt(this.dwSecurityUserService.securityState.securityContext.ApplicationUser);

    this.params[0] = wachterUser.trustUserId;
  }

  addEmployee() {

    this.message = null;

    if (!this.employeeIdToAdd) {
      return;
    }

    const employeeId = this.employeeIdToAdd;

    this.employeeIdToAdd = null;

    const existingReview = this.kickoffArgs.reviewSummaries.find(rs => rs.EmployeeEthosUserId == employeeId);

    if (existingReview) {
      this.message = {
        messageBody: 'Employee is already in the list',
        severity: DwMessageSeverity.warning
      };
      return;
    }

    this.pmRepositoryService.getEthosUserInfo(employeeId)
      .subscribe(ethosUser => {
        if (!ethosUser) {
          return;
        }

        const reviewSummary: EmployeeReviewSummaryEntity = {
          _itemName: PerformanceManagementMetaDataItemNames.EmployeeReviewSummary,
          EmployeeEthosUserId: ethosUser.UserId,
          SupervisorEthosUserId: ethosUser.SupervisorUserId,
          EmployeeReviewSummaryTypeId: 1,
          ReviewYear: moment().year(),
          EmployeeEthosUserIdDisplay: ethosUser.NameLastFirstPreferedType
        };

        this.kickoffArgs.reviewSummaries.push(reviewSummary);

        this.allowAddEmployees = false;
      });

  }



  startReviewSummarySave(): Observable<DwModalResult<any>> {
    // First, we need to reload the review summary and all evals
    const employeeIds = this.kickoffArgs.reviewSummaries.map(rs => rs.EmployeeEthosUserId);

    if (this.kickoffArgs.reviewSummaries.length == 0) {
      this.message = {
        messageBody: 'At least one employee must be listed',
        severity: DwMessageSeverity.error
      }
      return of({
        closeModal: false,
        cancelled: true,
      });
    }

    return this.pmRepositoryService.getEmployeeReviewSummaries(employeeIds, this.reviewYear)
      .pipe(mergeMap(reviewSummaries => {

        if (!this.validateEmployeeSummaries(reviewSummaries)) {

          return of({
            closeModal: false,
            cancelled: true,
          });
        }

        return this.updateReviewSummaries(this.kickoffArgs.reviewSummaries);
        // return of(modalResult);
      }));
  }


  private updateReviewSummaries(reviewSummaries: EmployeeReviewSummaryEntity[]): Observable<DwModalResult<EmployeeReviewKickoffModalResult>> {
    const modalResult: DwModalResult<EmployeeReviewKickoffModalResult> = {
      closeModal: false,
      cancelled: true,
    };

    for (const ers of reviewSummaries) {
      ers.EmployeeReviewSummaryStatusId = EmployeeReviewSummaryStatus.inProgress;
      ers.DueDate = this.reviewDueDate;
      ers.EmployeeReview = ers.EmployeeReview || [];

      if (!ers.EmployeeReview.find(r => !r.IsSupervisorReview)) {
        ers.EmployeeReview.push(this.createEmployeeReview(false));
      }

      for (const er of ers.EmployeeReview) {
        er.EmployeeReviewStatusId = EmployeeReviewStatus.notStarted;
        er.DueDate = this.evalDueDate
      }
    }

    return this.pmRepositoryService.saveEachEmployeeReviewSummaries(reviewSummaries)
      .pipe(map(savedReviewSummaries => {
        let supReviews : EmployeeReviewEntity[] = [];
        for (const ers of savedReviewSummaries) {
          if (!ers.EmployeeReview.find(r => r.IsSupervisorReview)) {
            let sr = this.createEmployeeReview(true);
            sr.EmployeeReviewSummaryId = ers.EmployeeReviewSummaryId;
            sr.EmployeeReviewStatusId = EmployeeReviewStatus.notStarted;
            sr.DueDate = this.evalDueDate;
            supReviews.push(sr);
          }
        }
        return { supReviews, savedReviewSummaries };
      }))
      .pipe(mergeMap(data =>  
      {
          return this.pmRepositoryService.saveEmployeeReviews(data.supReviews)
                    .pipe(map(results =>
                    {
                      for (const sr of results){
                        const summary = data.savedReviewSummaries.find(s => s.EmployeeReviewSummaryId == sr.EmployeeReviewSummaryId);
                        if (summary)
                          summary.EmployeeReview.push(sr);
                      }
                      modalResult.cancelled = false;
                      modalResult.closeModal = true;
                      modalResult.data = {
                        reviewSummaries: data.savedReviewSummaries
                      };
                      return modalResult;
                    }));
      }));
  }
  private createEmployeeReview(isSupervisorReview: boolean): EmployeeReviewEntity {
    return {
      IsSupervisorReview: isSupervisorReview,
      DueDate: this.evalDueDate,
      EmployeeReviewStatusId: EmployeeReviewStatus.notStarted,
      _itemName: PerformanceManagementMetaDataItemNames.EmployeeReview
    };
  }

  removeItem(reviewSummary: any) {
    const index = this.kickoffArgs.reviewSummaries.indexOf(reviewSummary);

    this.kickoffArgs.reviewSummaries.splice(index, 1);
  }

  validateEmployeeSummaries(reviewSummaries: EmployeeReviewSummaryEntity[]): boolean {
    const errors: { [prop: string]: string } = {};

    for (const ers of reviewSummaries) {
      if (ers.EmployeeReviewSummaryStatusId != EmployeeReviewSummaryStatus.notStarted && ers.EmployeeReviewSummaryStatusId != EmployeeReviewSummaryStatus.deleted) {
        errors.reviewStatusIncorrect = `An annual review already exists for ${ers.EmployeeEthosUserIdDisplay} for ${this.reviewYear}`;
      }

      // Add the employee reviews to the summaries we're going to save (since these came from the grid, the employee review data hasn't been loaded)
      var kickOffSummary = this.kickoffArgs.reviewSummaries.find(rs => rs.EmployeeReviewSummaryId == ers.EmployeeReviewSummaryId);

      if (kickOffSummary) {
        kickOffSummary.EmployeeReview = ers.EmployeeReview;
      }

      if (!isEmptyObject(errors)) {
        const errorList: string[] = [];

        for (const prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            errorList.push(errors[prop]);
          }
        }

        this.message = {
          messageHeading: 'We found a few issues that prevent us from kicking off the evaluations',
          messageBody: errorList.join(', '),
          severity: DwMessageSeverity.warning,
          allowClose: true,
        }

        return false;
      }
    }


    return true;
  }




}
